import { BimModel } from "./bim-model.interface";

export class CreateBimModelDto {
  name: string;
  description: string;
  disabled: boolean;
  externalId: string;
  parentBimModelId?: string;
  structureId?: string;

  constructor(bimModel: BimModel) {
    this.name = bimModel.name;
    this.description = bimModel.description;
    this.disabled = bimModel.disabled;
    this.externalId = bimModel.externalId;
    this.parentBimModelId = bimModel?.parentBimModelId
    this.structureId = bimModel?.structureId
  }
}

export class UpdateBimModelDto {
  name: string;
  description: string;
  disabled: boolean;
  externalId: string;
  structureId?: string;
  default?: boolean;
  visible?: boolean;

  constructor(bimModel: BimModel) {
    this.name = bimModel.name;
    this.description = bimModel.description;
    this.disabled = bimModel.disabled;
    this.structureId = bimModel?.structureId;
    this.externalId = bimModel.externalId;
    this.default = bimModel?.default;
    this.visible = bimModel?.visible;
  }
}
